import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoServicioTecnicoComponent } from './listado-servicio-tecnico/listado-servicio-tecnico.component';
import { MapaServicioTecnicoComponent } from './mapa-servicio-tecnico/mapa-servicio-tecnico.component';
import { PedidosMaterialesComponent } from './pedidos-materiales/pedidos-materiales.component';

const routes: Routes = [
  { path: '', redirectTo: 'servicios-tecnicos', pathMatch: 'full' },
  {
    path: 'servicios-tecnicos',
    title: 'Servicios técnicos',
    component: ListadoServicioTecnicoComponent,
    canActivate: [],
  },
  {
    path: 'mapa',
    title: 'Mapa de servicios técnicos',
    component: MapaServicioTecnicoComponent,
    canActivate: [],
  },
  {
    path: 'pedidos-materiales',
    title: 'Pedidos de materiales',
    component: PedidosMaterialesComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServicioTecnicoRoutingModule {}
